import {
  map, values, path,
} from 'ramda';
import { compose } from 'recompose';

import UserEditForm from './UserEditForm';
import { permissionsActions } from '../../../../../../../state/permissions';
import { withAutocomplete } from '../../../../../../../utils/enchancers';
import { renameKeys } from '../../../../../../../utils/helpers/commonHelpers';

const enhance = compose(
  withAutocomplete({
    name: 'getRolesAutocomplete',
    action: (params, meta) => permissionsActions.getRolesRequest(params,
      { ...meta, isAutocomplete: true }),
    dataPath: compose(
      map(renameKeys({ name: 'label', id: 'value' })),
      values,
      path(['data', 'entities', 'roles']),
    ),
    searchField: 'name',
    limitValue: 100
  }),
);

export default enhance(UserEditForm);
